<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        AddressForm,
        Heading,
        Paragraph,
        SESSION_ORGANIZATION,
        SESSION_USER,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import OnboardingProgressLine from '../../components/OnboardingProgressLine.svelte';

    /* TYPES ----------------------------------------------------------------------------------- */

    import type { Address } from 'src/app/types';

    /* INTERNALS -------------------------------------------------------------------------------- */

    $: organizationKey = $SESSION_ORGANIZATION?._.key;

    const ADDRESS: Partial<Address> = { organizationKey, type: 'main' };

</script>

{#if $SESSION_USER !== null}

    <Heading size = 'xl'>Nearly done!</Heading>
    <Heading size = 'md' style = 'subtle'>Thank you for signing up!</Heading>

    <Paragraph>
        To access our exclusive brand deals, your account requires approval,
        usually within 3-4 business days. To speed up this process,
        please provide us with more background information about your company.
    </Paragraph>

    <OnboardingProgressLine current = 'step3' />

    {#if organizationKey}
        <AddressForm action = 'create' address = { ADDRESS } { organizationKey } mode = 'buyer' />
    {/if}

{/if}